import { Feature } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/feature";
import { Features } from "@omni/ui/components/Product/Feature/KeyFeatures/components/features/features";
import { Base } from "@omni/ui/components/Product/Feature/KeyFeatures/keyFeatures.base";

import { useKeyFeaturesContext } from "@/components/Product/Feature/KeyFeatures/context/keyFeatures.context";

export const KeyFeatures = Object.assign(Base, {
    useContext: useKeyFeaturesContext,
    Features: Features,
    Feature: Feature
});
